import {compress, base64ToBlob} from './imgUtil'
import {checkCanGoRouter, isWxgzh, timeFilter, isEmpty, urlParams, getChannel, getTimer, clearOrderInfo, traverseSetItemText} from './utils'
import baiDuUtil from './baidu'
import {setCookie, getCookie} from '@/libs/utils/cookie'
import wxShare, { updateShareData, } from './wxShare'
export default {
  compress,
  base64ToBlob,
  checkCanGoRouter,
  isWxgzh,
  timeFilter,
  isEmpty,
  urlParams,
  getChannel,
  traverseSetItemText,
  baiDuUtil,
  getTimer,
  clearOrderInfo,
  setCookie,
  getCookie,
  wxShare,
  updateShareData
}



// WEBPACK FOOTER //
// ./src/libs/utils/index.js